import React, {Suspense, useEffect, useState} from 'react';
import {Spin, Tabs, Badge} from 'antd';
import {useParams, useNavigate} from "react-router-dom";
import {useSelector} from "react-redux";
import {io} from "socket.io-client";
import Error from "../../../../components/Error";

const LiveWatch = React.lazy(() => import("./Tabs/LiveWatch/LiveWatch"));
const TelTale = React.lazy(() => import("./Tabs/Teltale/index"));
const ErrorPage = React.lazy(() => import("./Tabs/LiveWatch/ErrorPage"));
const ErrorHistoryList = React.lazy(() => import("./Tabs/LiveWatch/ErrorHistoryList"));

const LiveDetail = () => {

    const {id, activeTab = "1"} = useParams();
    const {user} = useSelector(state => state.auth)
    const [selectedData, setSelectedData] = useState({});
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        setLoading(true)
        const socket = io('https://live.myoctoopidev.com', {
            reconnection: true,
            transports: ['websocket'],
            reconnectionDelay: 2000,
            reconnectionAttempts: 5,
            withCredentials: true,
            query: {
                'x-access-token': user?.token,
                'vehicle_id': id
            },
            transportOptions: {
                binary: true,
            },
        });

        socket.on('live', (data) => {
            setLoading(false)
            setSelectedData(data)
        });

        socket.on('reconnect', (event) => {
            console.log('you have been reconnected');
            console.log('Event => ', event);
        });

        socket.on('connect_error', (error) => {
            setError(true)
            console.log(error.name);
        });

        return () => {
            socket.disconnect();
        };
    }, [user?.token, id]);

    if (error) {
        return <Error status="404" title={error[0]} subtitle="Lütfen daha sonra tekrar deneyiniz."/>
    }

    if (!selectedData) {
        return <Error status="404" title={error[0]} subtitle="Lütfen daha sonra tekrar deneyiniz."/>
    }

    if (loading) {
        return (
            <Spin size="medium" style={{display: "flex", alignContent: "center", justifyContent: "center"}}/>
        );
    }


    return (
        <Tabs activeKey={activeTab}
              onChange={(activeKey) => navigate(`/live/${id}/${activeKey}`)}
              tabBarExtraContent={
                  selectedData ? (
                      <Badge
                          status={selectedData.onlineStatus === "online" ? "success" : "error"}
                          text={`${selectedData?.plateNumber || '-'} (${selectedData?.operationNumber || '-'})`}
                      />
                  ) : (
                      <Badge
                          status="error"
                          text={`- (-)`}
                      />
                  )
              }
        >
            <Tabs.TabPane disabled={!selectedData} tab="Canlı İzleme" key="1">
                <Suspense fallback={<Spin style={{textAlign: "center", justifyContent: "center"}}/>}>
                    <LiveWatch data={selectedData}/>
                </Suspense>
            </Tabs.TabPane>
            <Tabs.TabPane disabled={!selectedData} tab="Uyarılar" key="2">
                <Suspense fallback={<Spin style={{textAlign: "center", justifyContent: "center"}}/>}>
                    <TelTale data={selectedData}/>
                </Suspense>
            </Tabs.TabPane>
            <Tabs.TabPane disabled={!selectedData} tab="Arıza Detay Özeti" key="4">
                <Suspense fallback={<Spin style={{textAlign: "center", justifyContent: "center"}}/>}>
                    <ErrorPage data={selectedData}/>
                </Suspense>
            </Tabs.TabPane>
            <Tabs.TabPane disabled={!selectedData} tab="Arıza Detay Geçmişi" key="5">
                <Suspense fallback={<Spin style={{textAlign: "center", justifyContent: "center"}}/>}>
                    <ErrorHistoryList data={selectedData}/>
                </Suspense>
            </Tabs.TabPane>
        </Tabs>
    );


};

export default LiveDetail;
